module.exports = __webpack_public_path__ + "static/media/2018-MAT Survey Results.3eb47069.pdf";